import React, {} from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import Fab from '@material-ui/core/Fab';
import Mic from '@material-ui/icons/Mic';
import MicOff from '@material-ui/icons/MicOff';
import Tooltip from '@material-ui/core/Tooltip';
import {useDispatch, useSelector} from "react-redux";
import {toggleLocalAudio} from "../../redux/audioVideo/actions";

const useStyles = makeStyles((theme) =>
  createStyles({
    fab: {
      margin: theme.spacing(1),
    },
  })
);

export default function ToggleAudioButton(props) {
  const classes = useStyles();
  const isFacilitator = useSelector(state => state.audioVideo?.localState?.isFacilitator);
  const isAudioEnabled = useSelector(state => state.audioVideo?.localTracks?.audio?.isEnabled);
  const isAudioPublished = useSelector(state => state.audioVideo?.audioPublished);
  const hasMic = useSelector(state => state.audioVideo.localState?.hasMic);
  const consultState = useSelector(state => state.app.consultState);
  const dispatch = useDispatch();
  const isGroupConsult = useSelector(state => state.bookingDetails.room?.booking_summary?.group_consult) === 'Yes';
  const inConsult = consultState === 'in-consult';
  const enabled = (isAudioEnabled && !inConsult) || (inConsult && isAudioEnabled && isAudioPublished);

  const toggleAudioEnabled = () => dispatch(toggleLocalAudio());

  if (isGroupConsult && !hasMic && !isFacilitator) return null;

  return (
    <Tooltip
      {...(props.hidden ? { open: true } : {})}
      title={enabled ? 'Mute Audio' : 'Unmute Audio'}
      placement={props.hidden ? 'left' : 'top'}
      PopperProps={{ disablePortal: true }}
    >
      <Fab className={classes.fab} onClick={toggleAudioEnabled} disabled={props.disabled} data-cy-audio-toggle>
        {enabled ? <Mic /> : <MicOff />}
      </Fab>
    </Tooltip>
  );
}

ToggleAudioButton.defaultProps = {
  hidden: false,
};
